import { render, staticRenderFns } from "./swiper-box.vue?vue&type=template&id=2e36f564&scoped=true"
import script from "./swiper-box.vue?vue&type=script&lang=js"
export * from "./swiper-box.vue?vue&type=script&lang=js"
import style0 from "./swiper-box.vue?vue&type=style&index=0&id=2e36f564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36f564",
  null
  
)

export default component.exports